import { Outlet, useParams } from "react-router-dom";
import { useDateFromSearchParams } from "@/helpers/useTimeHooks";
import { useMemo } from "react";
import { Stack } from "@altimateai/lego";
import { TabWithOutlet } from "@/components/tab";
import { useAppState } from "@/modules/app/useAppContext";

export const DbtExecutions = () => {
  const { workflowId } = useParams();
  const { startDate, endDate } = useDateFromSearchParams();
  const { enableDbtJobsListing } = useAppState();

  const tabs = useMemo(() => {
    const dateQuery = `startDate=${startDate.toISOString()}&endDate=${endDate.toISOString()}`;
    const base = `/query/dbt-jobs/${encodeURIComponent(workflowId!)}`;
    return [
      ...(enableDbtJobsListing
        ? [{ label: "Jobs", path: `${base}/jobs?${dateQuery}` }]
        : []),
      { label: "Models", path: `${base}/models?${dateQuery}` },
      { label: "Runs", path: `${base}/runs?${dateQuery}` },
    ];
  }, [workflowId, startDate, endDate, enableDbtJobsListing]);

  return (
    <Stack direction={"column"} gap={"none"}>
      <TabWithOutlet tabs={tabs} />
      <Outlet />
    </Stack>
  );
};
